// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1b-1";
export var movingGradient = "_1b-4";
export var movingGradientBlock = "_1b-2";
export var skeleton = "_1b-0";
export var skeletonText = "_1b-3";